import Reflux from "reflux";
export const FeatureActions = {
	setMembership: Reflux.createAction(["setMembership"]),
	recalculateMemberships: Reflux.createAction(["recalculateMemberships"]),
};
